import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

export const loadFaculty = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  return api.get("/faculty").then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); return cache; });
};

export const useFaculty = () => {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    let on = true;
    const sync = (d) => on && setList(d);
    listeners.add(sync);
    loadFaculty().then(sync).catch(() => {});
    return () => { on = false; listeners.delete(sync); };
  }, []);
  return list;
};
